import { useCallback } from 'react';

import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { StatusBadge } from '@/components/common/status-badge';

interface EmbryoDetailsToolbarProps {
  embryoName?: string;
  onSave?: () => void;
  isSaveDisabled?: boolean;
  isSaving?: boolean;
  isInactive?: boolean;
}

export const EmbryoDetailsToolbar = ({
  onSave,
  isSaveDisabled = false,
  isSaving = false,
  isInactive = false,
}: EmbryoDetailsToolbarProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClose = useCallback(() => {
    navigate('/embryo');
  }, [navigate]);

  return (
    <div className="flex items-center justify-end gap-2 bg-white p-2">
      {isInactive && (
        <div className="mr-auto">
          <StatusBadge
            label={t('embryo.inactive')}
            colorMap={{}}
            fallback={{ bg: 'bg-red-500', text: 'text-white' }}
          />
        </div>
      )}
      <Button
        type="button"
        label={t('common.save')}
        icon="pi pi-save"
        disabled={isSaveDisabled}
        loading={isSaving}
        onClick={onSave}
      />
      <Button
        type="button"
        label={t('common.close')}
        icon="pi pi-times"
        severity="secondary"
        onClick={handleClose}
      />
    </div>
  );
};
